import Empty from "../layouts/auth/auth.layout";
import React from "react";
import { Grid } from "@mui/material";
import { useLanguage } from "locale/useLanguage";
import { Logo } from "./Logo";

type GeneralErrorProps = {};

const GeneralError: React.FC<GeneralErrorProps> = () => {
  const [t] = useLanguage();

  return (
    <Empty>
      <Grid container className="general-error--container">
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignContent="flex-end"
        >
          <Logo className="general-error--image" />
        </Grid>
        <Grid className="general-error--content">
          <h2>{t("genericError.title")}</h2>
          <p>{t("genericError.text")}</p>
        </Grid>
        <Grid className="general-error--exit-container">
          {/* <Grid className="general-error--exit-button">
            <Button onClick={close}>{t("genericError.close")}</Button>
          </Grid> */}
        </Grid>
      </Grid>
    </Empty>
  );
};

export default GeneralError;
